const { getOffsetTop } = window.BAO.Utils

class MediaScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.setupSizes = this.setupSizes.bind(this)

    this.setupSizes()

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    if (!this.els.thumbnail?.exists) return
    this.handleThumbnail = this.handleThumbnail.bind(this)

    this.els.thumbnail.elements.forEach((thumbnailEl) => {
      this.listeners.add(thumbnailEl, 'click', this.handleThumbnail)
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveMedia()
  }

  setupSizes () {
    const roundedHeight = Math.round(this.mediaViewportPercent)

    this.style.setProperty(
      '--Media_Total',
      `${roundedHeight > 100 ? roundedHeight : 110}vh`,
    )
  }

  moveMedia () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const navigationColumnWidth = 190
    const detailsColumnWidth = 300

    const navWidthPercent = (navigationColumnWidth / window.innerWidth) * 100
    const detailsWidthPercent = (detailsColumnWidth / window.innerWidth) * 100
    const scrollerViewportWidth = window.BAO.MediaBreakpoints.isMd
      ? 100 - navWidthPercent - detailsWidthPercent
      : 100 - detailsWidthPercent

    const maxScrollAmount = this.mediaViewportPercent - scrollerViewportWidth

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.setProperty('--Scroll_Amount', `0vw`)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.setProperty('--Scroll_Amount', `-${maxScrollAmount}vw`)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const scrollAmount = maxScrollAmount * scrollYAsAPercentageOfJourney

    this.style.setProperty('--Scroll_Amount', `-${scrollAmount}vw`)

    if (!this.els.thumbnail?.exists) return

    this.els?.thumbnail?.elements.forEach((thumbEl) => {
      const thumbIndex = parseInt(thumbEl.dataset.index)
      const thumbMaxIndex = parseInt(thumbEl.dataset.maxIndex)

      const minimumPercent = thumbIndex / (thumbMaxIndex + 1)
      const maximumPercent = (thumbIndex + 1) / (thumbMaxIndex + 1)
      const isWithinRange =
        scrollYAsAPercentageOfJourney >= minimumPercent &&
        scrollYAsAPercentageOfJourney < maximumPercent

      if (isWithinRange) {
        thumbEl.setAttribute('aria-pressed', true)
      } else {
        thumbEl.setAttribute('aria-pressed', false)
      }
    })
  }

  handleThumbnail (event) {
    if (!event.target.closest(this.els?.thumbnail?.selector)) return

    const clickedTrigger = event.target.closest(this.els?.thumbnail?.selector)

    const clickedIndex = parseInt(clickedTrigger.dataset.index)
    const maxIndex = parseInt(clickedTrigger.dataset.maxIndex)

    const elementStartPoint = getOffsetTop(this)
    const elementHeight = this.offsetHeight - window.innerHeight

    const scrollCalc = (elementHeight / maxIndex) * clickedIndex
    const scrollPosition = elementStartPoint + scrollCalc

    window.scrollTo({
      top: scrollPosition - 30,
      left: 0,
      behavior: 'smooth',
    })
  }

  get mediaViewportPercent () {
    const mediaItemsWidth = this.els.item.elements.reduce(
      (accumulator, currentValue) => {
        return accumulator + currentValue.offsetWidth
      },
      0,
    )

    const mediaWidthViewportPercent =
      (mediaItemsWidth / window.innerWidth) * 100

    return mediaWidthViewportPercent
  }
}

if (!customElements.get('media-scroll')) {
  customElements.define('media-scroll', MediaScroll)
}
